export default "__VITE_ASSET__BeEgSU_7__"